import React, { useContext, useState } from 'react'

import { collection, getDocs, doc, setDoc, query, where, updateDoc, serverTimestamp, getDoc } from "firebase/firestore";
import { db } from '../firebase';
import { AuthContext } from '../context/AuthContext';

const Search = () => {
    const [userName, setUserName] = useState("")
    const [user, setUser] = useState(null)
    const [err, setErr] = useState(false)

    const { currentUser } = useContext(AuthContext)

    const handlesearch = async () => {

        const q = query(collection(db, "users"), where("displayName", "==", userName));

        try {
            const querySnapshot = await getDocs(q);


            querySnapshot.forEach((doc) => {


                setUser(doc.data())
            });
        } catch (error) {

            setErr(true)

        }



    }

    const handleKeyDown = (e) => {
        e.code === "Enter" && handlesearch()
    }

    const handleSelect = async () => {
        // check if chat alredy exist or not

        const combinedId = currentUser.uid > user.uid ? currentUser.uid + user.uid : user.uid + currentUser.uid
        console.log("func called", combinedId);
        try {

            const res = await getDoc(doc(db, "chats", combinedId))

            console.log("first log", res);

            if (!res.exists()) {
                //create a chat in chats collection
                await setDoc(doc(db, "chats", combinedId), { messages: [] })
                console.log("second log");

                // create user Chats

                await updateDoc(doc(db, "userChats", currentUser.uid), {
                    [combinedId + ".userInfo"]: {
                        uid: user.uid,
                        displayName: user.displayName,
                        photoURL: user.photoURL
                    },
                    [combinedId + ".date"]: serverTimestamp()
                })
                //for other user
                await updateDoc(doc(db, "userChats", user.uid), {
                    [combinedId + ".userInfo"]: {
                        uid: currentUser.uid,
                        displayName: currentUser.displayName,
                        photoURL: currentUser.photoURL
                    },
                    [combinedId + ".date"]: serverTimestamp()
                })


            }

        } catch (error) {

            console.log(error);
            setErr(true)
        }

        setUser(null)
        setUserName("")
    }

    return (
        <div className="search">
            <div className="searchForm">
                <input type="text" placeholder="Find a user" value={userName} className="" onKeyDown={handleKeyDown} onChange={(e) => setUserName(e.target.value)} />
            </div>
            {err && <span>User bot Found!</span>}
            {
                user && <div className="userChat" onClick={handleSelect}>
                    <img src={user.photoURL} alt="" />

                    <div className="userChatInfo">
                        <span>{user.displayName}</span>
                    </div>
                </div>
            }
        </div>
    )
}

export default Search





